import { useInView } from '../../hooks/useInView';
import { UserPlus, Link as LinkIcon, LineChart } from 'lucide-react';

const steps = [
  {
    number: '1',
    icon: UserPlus,
    title: 'Crie sua conta',
    description: 'Escolha seu plano e acesse o painel de controle financeiro completo em minutos.',
  },
  {
    number: '2',
    icon: LinkIcon,
    title: 'Conecte o WhatsApp',
    description: 'Vincule seu número e comece a registrar gastos, consultar saldo e gerenciar metas por mensagem.',
  },
  {
    number: '3',
    icon: LineChart,
    title: 'Acompanhe e projete',
    description: 'Visualize gráficos de evolução, projeções com IA e receba resumos diários automáticos no WhatsApp.',
  },
];

export default function HowItWorksSection() {
  const [ref, isInView] = useInView({ threshold: 0.15 });

  return (
    <section className="relative py-32 overflow-hidden" data-testid="how-it-works-section">
      <div className="absolute inset-0 bg-gradient-to-b from-background via-muted/15 to-background" />

      <div className="relative mx-auto max-w-6xl px-6" ref={ref}>
        <div className={`text-center max-w-2xl mx-auto mb-16 transition-all duration-700 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="text-xs font-semibold uppercase tracking-widest text-primary mb-4 block">
            Como funciona
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-foreground mb-6">
            Como funciona o controle financeiro?
          </h2>
          <p className="text-muted-foreground text-lg">
            Comece a organizar suas finanças pessoais em 3 passos simples.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 relative">
          {/* connector line */}
          <div className="hidden md:block absolute top-16 left-[16.66%] right-[16.66%] h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />

          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div
                key={step.number}
                data-testid={`step-${step.number}`}
                className={`relative text-center transition-all duration-700 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
                style={{ transitionDelay: `${index * 150}ms` }}
              >
                <div className="relative inline-flex items-center justify-center mb-6">
                  <div className="absolute inset-0 rounded-full bg-primary/20 blur-xl" />
                  <div className="relative w-20 h-20 rounded-full bg-card border border-border/60 shadow-lg flex items-center justify-center">
                    <Icon className="w-8 h-8 text-primary" />
                  </div>
                  <span className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-primary text-primary-foreground text-sm font-bold flex items-center justify-center shadow-md">
                    {step.number}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-foreground mb-3 tracking-tight">{step.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed max-w-xs mx-auto">{step.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
